import {
    NOTIFY_ERROR,
    DISMISS_MESSAGE,
    DISMISS_ALL_MESSAGES,
    NOTIFY_COMPLETE_CHECKOUT_ERROR, 
    REMOVE_BILLING_ADDRESS,
    REMOVE_SHIPPING_ADDRESS,
    SELECT_BILLING_ADDRESS,
    SELECT_SHIPPING_ADDRESS,
    SELECT_SHIPPING_AND_BILLING_ADDRESS,
    UPDATE_ADDRESS,
    USE_BILLING_FOR_SHIPPING_TOGGLE,
    UPDATE_ITEM_QUANTITY,
    DELETE_ITEM,
    UPDATING_COUPONS,
    SELECT_PAYMENT_OPTION,
    BRAINTREEE_PAYMENT_DATA_UPDATE,
    BRAINTREEE_BILLING_ADDRESS_UPDATE,
    BRAINTREEE_SAVE_CARD_UPDATE,
    PURCHASE_ORDER_PAYMENT_DATA_UPDATE,
    SELECT_SHIPPING_OPTION, 
    NEW_SHIPPING_OPTIONS,
} from '../../GlobalStateContainer'

import {
    ERROR_USER_ALERT,
    UNKNOWN_USER_ALERT
} from './userAlertTypes'

import {
    addToList,
    replaceInListById
} from '../../../util/listUtility'

import { translateResourceString } from '../../../util/translationUtility';

const mapActionTypeToUserAlertType = (actionType) => {
    switch (actionType) {
        case NOTIFY_ERROR:
        case NOTIFY_COMPLETE_CHECKOUT_ERROR:
            return ERROR_USER_ALERT;
        default:
            return UNKNOWN_USER_ALERT;
    }
}

export function messages(state = [], action) {
    switch (action.type) {
        case NOTIFY_ERROR:
            return addToList(
                state,
                {
                    type: mapActionTypeToUserAlertType(action.type),
                    text: action.message,
                    Id: action.messageId
                });
        case NOTIFY_COMPLETE_CHECKOUT_ERROR:
            return addToList(
                state,
                {
                    type: mapActionTypeToUserAlertType(action.type),
                    text: action.message,
                    Id: action.messageId
                });
        case DISMISS_MESSAGE:
            return replaceInListById(
                state,
                action.messageId,
                Object.assign({}, state.filter(m => m.Id === action.messageId)[0], { dismissed: true }))
        case DISMISS_ALL_MESSAGES:
        // ADDRESS ACTIONS
        case REMOVE_BILLING_ADDRESS: 
        case REMOVE_SHIPPING_ADDRESS:
        case SELECT_BILLING_ADDRESS: 
        case SELECT_SHIPPING_ADDRESS:
        case SELECT_SHIPPING_AND_BILLING_ADDRESS: 
        case UPDATE_ADDRESS:
        case USE_BILLING_FOR_SHIPPING_TOGGLE:
        // CART ACTIONS
        case UPDATE_ITEM_QUANTITY:
        case DELETE_ITEM:
        // COUPONS ACTIONS
        case UPDATING_COUPONS:
        // PAYMENT METHOD ACTIONS
        case SELECT_PAYMENT_OPTION:
        case BRAINTREEE_PAYMENT_DATA_UPDATE:
        case BRAINTREEE_BILLING_ADDRESS_UPDATE:
        case BRAINTREEE_SAVE_CARD_UPDATE:
        case PURCHASE_ORDER_PAYMENT_DATA_UPDATE:
        // SHIPPING ACTIONS
        case SELECT_SHIPPING_OPTION: 
        case NEW_SHIPPING_OPTIONS:
            return [];
        default:
            return state;
    }
}
